'use client'

import { Spacer } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useBanners } from '@marketplace-web/banners/banners-feature'
import { TaxpayerBannerRenderLocation } from '@marketplace-web/taxpayers/taxpayers-data'

import TaxpayerBanner from '../TaxpayerBanner'

const ProfileTaxpayerBanner = () => {
  const isTaxpayerSpecialVerificationBannerFsEnabled = useFeatureSwitch(
    'web_special_verification_taxpayers_banners',
  )

  const { banners } = useBanners()

  const { taxpayerBanner } = banners

  if (!taxpayerBanner) return null

  const isTaxpayersSpecialVerificationBanner = taxpayerBanner.isSpecialVerification

  const shouldDisplayBanner =
    !isTaxpayersSpecialVerificationBanner ||
    (isTaxpayersSpecialVerificationBanner && isTaxpayerSpecialVerificationBannerFsEnabled)

  if (!shouldDisplayBanner) return null

  return (
    <>
      <TaxpayerBanner
        banner={taxpayerBanner}
        isBannerInFeed={false}
        screen="current_user_profile"
        renderLocation={TaxpayerBannerRenderLocation.Wardrobe}
      />
      <Spacer size={Spacer.Size.Large} />
    </>
  )
}

export default ProfileTaxpayerBanner
